import { TextCodes } from '@api/types/translation/TextCodes';
import { LoadingSkeleton } from '@components/common/loading';
import { FilterAlt } from '@mui/icons-material';
import { Paper, styled, TextField } from '@mui/material';
import { t } from '@translations';

const StyledPaper = styled(Paper)`
  padding: 16px;
  display: flex;
  cursor: pointer;
`;

export type MobileCategoryIndicatorProps = {
  title?: string;
  onClick: Function;
  isWorking?: boolean;
};

export const SearchFilterButton = ({
  onClick,
  isWorking,
  title = t(TextCodes.Base.SelectFilter),
}: MobileCategoryIndicatorProps) => {
  return isWorking ? (
    <StyledPaper elevation={0}>
      <LoadingSkeleton sx={{ width: '100%' }} />
    </StyledPaper>
  ) : (
    <TextField
      label={t(TextCodes.Search.Category)}
      value={title}
      onClick={() => onClick()}
      sx={{
        mt: 2,
        '& .MuiInputBase-root input': {
          cursor: 'pointer !important',
        },
      }}
      InputProps={{
        readOnly: true,
        endAdornment: <FilterAlt />,
      }}
    />
  );
};
